/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AssignPersonToTaskInput = {
    taskId?: string | null | undefined;
    personId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type AssignPersonToTaskMutationVariables = {
    input: AssignPersonToTaskInput;
};
export type AssignPersonToTaskMutationResponse = {
    readonly assignPersonToTask: {
        readonly errors: ReadonlyArray<string | null> | null;
        readonly task: {
            readonly id: string;
            readonly assignedPersons: ReadonlyArray<{
                readonly id: string;
            } | null> | null;
            readonly parentTaskId: string | null;
            readonly parentTask: {
                readonly id: string;
            } | null;
            readonly billable: boolean | null;
            readonly blocked: boolean | null;
            readonly bug: boolean | null;
            readonly companyTaskId: number | null;
            readonly deadlineDay: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineYear: number | null;
            readonly deadlineFrom: string | null;
            readonly startFrom: string | null;
            readonly done: boolean | null;
            readonly highPriority: boolean | null;
            readonly role: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly phase: {
                readonly id: string;
                readonly progress: number | null;
                readonly progressDetails: {
                    readonly progress: number | null;
                } | null;
            } | null;
            readonly sprint: {
                readonly id: string;
            } | null;
            readonly statusColumnV2: {
                readonly id: string;
            } | null;
            readonly progress: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
            readonly timeLeft: number | null;
            readonly timeLeftMinutesWithoutFutureTimeRegs: number | null;
            readonly hasChildren: boolean | null;
            readonly name: string | null;
            readonly progressDetails: {
                readonly progress: number | null;
            } | null;
            readonly estimateForecast: number | null;
            readonly estimateForecastPrice: number | null;
            readonly estimateForecastMinutes: number | null;
            readonly approved: boolean | null;
            readonly currentPrice: number | null;
            readonly allTotalTimeAndExpensesAtCompletion: number | null;
            readonly plannedCost: number | null;
            readonly actualCost: number | null;
            readonly taskLabels: ReadonlyArray<{
                readonly label: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly color: string | null;
                } | null;
            } | null> | null;
            readonly project: {
                readonly id: string;
                readonly completion: number | null;
                readonly remaining: number | null;
                readonly forecast: number | null;
                readonly progress: number | null;
                readonly progressDetails: {
                    readonly progress: number | null;
                } | null;
            } | null;
            readonly owner: {
                readonly id: string;
            } | null;
            readonly followers: ReadonlyArray<{
                readonly id: string;
            } | null> | null;
            readonly timeRegistrations: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly billableMinutesRegistered: number | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type AssignPersonToTaskMutation = {
    readonly response: AssignPersonToTaskMutationResponse;
    readonly variables: AssignPersonToTaskMutationVariables;
};



/*
mutation AssignPersonToTaskMutation(
  $input: AssignPersonToTaskInput!
) {
  assignPersonToTask(input: $input) {
    errors
    task {
      id
      assignedPersons {
        id
      }
      parentTaskId
      parentTask {
        id
      }
      billable
      blocked
      bug
      companyTaskId
      deadlineDay
      deadlineMonth
      deadlineYear
      deadlineFrom
      startFrom
      done
      highPriority
      role {
        id
        name
      }
      phase {
        id
        progress
        progressDetails {
          progress
          id
        }
      }
      sprint {
        id
      }
      statusColumnV2 {
        id
      }
      progress
      startDay
      startMonth
      startYear
      timeLeft
      timeLeftMinutesWithoutFutureTimeRegs
      hasChildren
      name
      progressDetails {
        progress
        id
      }
      estimateForecast
      estimateForecastPrice
      estimateForecastMinutes
      approved
      currentPrice
      allTotalTimeAndExpensesAtCompletion
      plannedCost
      actualCost
      taskLabels {
        label {
          id
          name
          color
        }
        id
      }
      project {
        id
        completion
        remaining
        forecast
        progress
        progressDetails {
          progress
          id
        }
      }
      owner {
        id
      }
      followers {
        id
      }
      timeRegistrations {
        edges {
          node {
            billableMinutesRegistered
            id
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "AssignPersonToTaskInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "assignedPersons",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Sprint",
  "kind": "LinkedField",
  "name": "sprint",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeftMinutesWithoutFutureTimeRegs",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastPrice",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentPrice",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedCost",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completion",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remaining",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecast",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v46 = [
  (v21/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignPersonToTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignPersonToTaskPayload",
        "kind": "LinkedField",
        "name": "assignPersonToTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProgress",
                "kind": "LinkedField",
                "name": "progressDetails",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabel",
                "kind": "LinkedField",
                "name": "taskLabels",
                "plural": true,
                "selections": [
                  (v39/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v22/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegTypeConnection",
                "kind": "LinkedField",
                "name": "timeRegistrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignPersonToTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignPersonToTaskPayload",
        "kind": "LinkedField",
        "name": "assignPersonToTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProgress",
                "kind": "LinkedField",
                "name": "progressDetails",
                "plural": false,
                "selections": (v46/*: any*/),
                "storageKey": null
              },
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabel",
                "kind": "LinkedField",
                "name": "taskLabels",
                "plural": true,
                "selections": [
                  (v39/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegTypeConnection",
                "kind": "LinkedField",
                "name": "timeRegistrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AssignPersonToTaskMutation",
    "operationKind": "mutation",
    "text": "mutation AssignPersonToTaskMutation(\n  $input: AssignPersonToTaskInput!\n) {\n  assignPersonToTask(input: $input) {\n    errors\n    task {\n      id\n      assignedPersons {\n        id\n      }\n      parentTaskId\n      parentTask {\n        id\n      }\n      billable\n      blocked\n      bug\n      companyTaskId\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n      deadlineFrom\n      startFrom\n      done\n      highPriority\n      role {\n        id\n        name\n      }\n      phase {\n        id\n        progress\n        progressDetails {\n          progress\n          id\n        }\n      }\n      sprint {\n        id\n      }\n      statusColumnV2 {\n        id\n      }\n      progress\n      startDay\n      startMonth\n      startYear\n      timeLeft\n      timeLeftMinutesWithoutFutureTimeRegs\n      hasChildren\n      name\n      progressDetails {\n        progress\n        id\n      }\n      estimateForecast\n      estimateForecastPrice\n      estimateForecastMinutes\n      approved\n      currentPrice\n      allTotalTimeAndExpensesAtCompletion\n      plannedCost\n      actualCost\n      taskLabels {\n        label {\n          id\n          name\n          color\n        }\n        id\n      }\n      project {\n        id\n        completion\n        remaining\n        forecast\n        progress\n        progressDetails {\n          progress\n          id\n        }\n      }\n      owner {\n        id\n      }\n      followers {\n        id\n      }\n      timeRegistrations {\n        edges {\n          node {\n            billableMinutesRegistered\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e699d38fb52c971c316851033c90e1a0';
export default node;
